module.exports = __webpack_public_path__ + "static/media/ended.c55e52ed.jpg";